export default {
    workOrder_createEditCustomer_createTitle: "Crear Nuevo Cliente",
    workOrder_createEditCustomer_editTitle: "Editar Cliente",
    workOrder_createEditCustomer_customerSaved: "Cliente guardado",
    workOrder_createEditCustomer_customerNameIsAlreadyInUse: "El nombre del cliente ya está en uso",
    workOrder_createEditCustomer_customerEinIsAlreadyInUse: "El EIN del cliente ya está en uso",
    workOrder_createEditCustomer_contactNameIsAlreadyInUse: "El nombre del contacto ya está en uso",
    workOrder_createEditCustomer_contactPhoneIsAlreadyInUse: "El teléfono del contacto ya está en uso",
    workOrder_createEditCustomer_contactEmailIsAlreadyInUse: "El correo del contacto ya está en uso",
    workOrder_createEditCustomer_locationNameIsAlreadyInUse: "El nombre de la ubicación ya está en uso",
    workOrder_createEditCustomer_name: "Nombre",
    workOrder_createEditCustomer_ein: "EIN",
    workOrder_createEditCustomer_mainContact: "Contacto Principal",
    workOrder_createEditCustomer_phone: "Teléfono",
    workOrder_createEditCustomer_email: "Correo Electrónico",
    workOrder_createEditCustomer_notifyByPhone: "Notificar por Teléfono",
    workOrder_createEditCustomer_notifyByEmail: "Notificar por Correo",
    workOrder_createEditCustomer_mainLocation: "Ubicación Principal",
    workOrder_createEditCustomer_address: "Dirección",
    workOrder_createEditCustomer_tags: "Etiquetas",
    workOrder_createEditCustomer_tagsSearch: "Buscar etiquetas disponibles",
    workOrder_createEditCustomer_contact: "Descripción",
    workOrder_settingsTagsSearch: "Buscar etiquetas disponibles",
    workOrder_createEditCustomer_errorPhone: "Hay que añadir el número de teléfono",
    workOrder_createEditCustomer_addressFormarError: "La dirección no es válida",
    workOrder_createEditCustomer_codeCountry: "Código País"
};